/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { ActivateBookingGuestRegistrationPayload } from 'api/actions/activate-booking-guest-registration/activate-booking-guest-registration-payload';
import { ActivateBookingGuestRegistrationPathParameters } from 'api/actions/activate-booking-guest-registration/activate-booking-guest-registration-path-parameters';
import { ActivateBookingGuestRegistrationResponse } from 'api/actions/activate-booking-guest-registration/activate-booking-guest-registration-response';

type ActivateBookingGuestRegistrationQueryParameters = Record<string, any>;

/**
 * The path of the ActivateBookingGuestRegistration action.
 */
export const activateBookingGuestRegistrationActionPath = new SweetPath<
  keyof ActivateBookingGuestRegistrationPathParameters
>('/reservations/public/registrations/activate', { path: '{param}' });

/**
 * Creates a contextualized ActivateBookingGuestRegistration actions.
 */
export default function createActivateBookingGuestRegistrationAction(axios: AxiosInstance) {
  return function activateBookingGuestRegistrationAction({
    headers = {},
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    query?: ActivateBookingGuestRegistrationQueryParameters;
    payload: ActivateBookingGuestRegistrationPayload;
  }) {
    const path = activateBookingGuestRegistrationActionPath.original;

    return axios.post<
      ActivateBookingGuestRegistrationResponse,
      ActivateBookingGuestRegistrationResponse,
      ActivateBookingGuestRegistrationPayload
    >(path, payload);
  };
}
